<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-积分管理-积分明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" placeholder="用户ID"></el-input>
        </el-form-item>
        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="settled_log_id" label="入驻记录ID" width="100"></el-table-column>
          <el-table-column prop="user_role_id" label="角色ID" width="80"></el-table-column>
          
          <el-table-column label="用户信息" width="120">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center;">
                <img v-if="scope.row.avatarUrl" :src="scope.row.avatarUrl" width="30" height="30" style="border-radius: 50%; margin-right: 8px;" />
                <div>
                  <div>{{ scope.row.nickName || '未设置' }}</div>
                  <div class="gray9">ID: {{ scope.row.user_id }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
          
          <el-table-column label="身份证照片" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.idcard_front || scope.row.idcard_back">
                <el-popover placement="right" trigger="hover" v-if="scope.row.idcard_front">
                  <img :src="scope.row.idcard_front" style="max-width: 300px; max-height: 200px;" />
                  <span slot="reference" class="preview-text">正面</span>
                </el-popover>
                <el-popover placement="right" trigger="hover" v-if="scope.row.idcard_back">
                  <img :src="scope.row.idcard_back" style="max-width: 300px; max-height: 200px;" />
                  <span slot="reference" class="preview-text">反面</span>
                </el-popover>
              </div>
              <span v-else>未上传</span>
            </template>
          </el-table-column>
          
          <!-- <el-table-column label="个人照片" width="100">
            <template slot-scope="scope">
              <el-popover placement="right" trigger="hover" v-if="scope.row.personalPhoto">
                <img :src="scope.row.personalPhoto" style="max-width: 300px; max-height: 200px;" />
                <img slot="reference" :src="scope.row.personalPhoto" width="30" height="30" style="border-radius: 4px;" />
              </el-popover>
              <span v-else>未上传</span>
            </template>
          </el-table-column> -->
          
          <el-table-column prop="phone" label="联系电话" width="120"></el-table-column>
          
          <!-- <el-table-column prop="email" label="邮箱" width="150"></el-table-column> -->
          
          <el-table-column label="审核状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : scope.row.status === 0 ? 'warning' : 'danger'">
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column prop="create_time" label="创建时间" width="160">
            <template slot-scope="scope">
              {{ formatTime(scope.row.create_time) }}
            </template>
          </el-table-column>
          
          <el-table-column prop="update_time" label="更新时间" width="160">
            <template slot-scope="scope">
              {{ formatTime(scope.row.update_time) }}
            </template>
          </el-table-column>
          
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope">
              <div>
                <el-button v-if="scope.row.status == 0" @click="editClick(scope.row)" type="text" size="small">
                  审核
                </el-button>
                <el-button @click="viewDetail(scope.row)" type="text" size="small">
                  详情
                </el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small" style="color: #F56C6C;">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination 
          @size-change="handleSizeChange" 
          @current-change="handleCurrentChange" 
          background 
          :current-page="curPage"
          :page-size="pageSize" 
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
   
   <Edit v-if="open_edit" :open_edit="open_edit" :form="currentRecord" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
   <Detail v-if="open_detail" :open_detail="open_detail" :form="currentRecord" @closeDialog="closeDialogFunc($event, 'detail')"></Detail>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  import Edit from './Serrlededit.vue';
  import Detail from './Detail.vue'; // 需要创建详情组件

  export default {
    components: {
      Edit,
      Detail
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          user_id: '',
          create_time: ''
        },
        /*当前操作的对象*/
        currentRecord: {},
        /*是否打开编辑弹窗*/
        open_edit: false,
        open_detail: false,
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.loading = true;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = {
          page: self.curPage,
          list_rows: self.pageSize,
          user_id: self.formInline.user_id,
          start_time: self.formInline.create_time ? self.formInline.create_time[0] : '',
          end_time: self.formInline.create_time ? self.formInline.create_time[1] : ''
        };
        
        UserApi.settledList(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.data; // 根据新接口结构调整
          self.totalDataNumber = data.data.total;
        }).catch(error => {
          self.loading = false;
          console.error('获取数据失败:', error);
        });
      },

      /*状态文本转换*/
      getStatusText(status) {
        const statusMap = {
          0: '待审核',
          1: '审核通过',
          2: '审核拒绝'
        };
        return statusMap[status] || '未知状态';
      },

      /*时间格式化*/
      formatTime(timestamp) {
        if (!timestamp) return '';
        const date = new Date(timestamp * 1000);
        return date.toLocaleString();
      },

      /*打开审核弹窗*/
      editClick(record) {
        this.currentRecord = {...record};
        this.open_edit = true;
      },

      /*查看详情*/
      viewDetail(record) {
        this.currentRecord = {...record};
        this.open_detail = true;
      },

      /*删除记录*/
      deleteClick(record) {
        this.$confirm('确定要删除这条入驻记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          UserApi.deleteSettled({ settled_log_id: record.settled_log_id }).then(res => {
            if (res.code === 1) {
              this.$message.success('删除成功');
              this.getTableList();
            } else {
              this.$message.error(res.msg || '删除失败');
            }
          }).catch(error => {
            this.$message.error('删除失败');
          });
        }).catch(() => {});
      },

      /*关闭弹窗*/
      closeDialogFunc(e, type) {
        if (type === 'edit') {
          this.open_edit = e.openDialog;
          if (e.type === 'success') {
            this.getTableList();
          }
        }
        if (type === 'detail') {
          this.open_detail = e.openDialog;
        }
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.loading = true;
        this.getTableList();
      },
    }
  };
</script>

<style>
.gray9 {
  color: #999;
  font-size: 12px;
}

.preview-text {
  color: #409EFF;
  cursor: pointer;
  margin-right: 8px;
  text-decoration: underline;
}

.preview-text:hover {
  color: #67C23A;
}
</style>


// WEBPACK FOOTER //
// src/views/user/setting/part/Settled.vue